module.exports = __webpack_public_path__ + "img/logo_image.9a22fe8f.svg";